import _ from '@lodash';
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';

function TableFilterStringLikeField(props) {
	const filterList = useSelector(rootState => rootState[props.config.key].tableBrowserFilter.filterList);
	const [value, setValue] = useState('');

	useEffect(() => {
		const index = filterList.findIndex(el => el.propertyName === props.filterConfig.propertyName);
		if (index > -1) {
			setValue(filterList[index].value);
		} else {
			setValue('');
		}
	}, [filterList]);

	useEffect(() => {
		const timeOutId = setTimeout(() => {
			if (_.isString(value) && value.length > 0) {
				const filterValue = {
					propertyName: props.filterConfig.propertyName,
					type: props.filterConfig.type,
					value
				};
				props.onFilterChanged(filterValue);
			} else {
				props.onFilterRemoved(props.filterConfig.propertyName);
			}
		}, 500);
		return () => clearTimeout(timeOutId);
	}, [value]);

	return (
		<div>
			<TextField margin="dense" label={props.filterConfig.text} fullWidth value={value} onChange={e => setValue(e.target.value)} />
		</div>
	);
}

export default TableFilterStringLikeField;
